// extracted by mini-css-extract-plugin
module.exports = {"connect-btn":"WalletModal_connect-btn__Xr9e-"};